/// <amd-module name="Build/ApprovalsPanel/ChecksPanelService" />
import { IChecksPanelService } from "Build/ApprovalsPanel/ChecksPanelService.types";
import { ApprovalStatus, ApprovalPermissions } from "Build/Client/Contracts/Approval";
import { ApprovalDetails, ChecksPanelData, CheckListItemType } from "Build/Client/Contracts/DataProvider";

import { IObservableArray, ObservableArray } from "VSS/Core/Observable"
import { Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssPageService } from "VSS/Platform/Page";

export class ChecksPanelService extends VssService implements IChecksPanelService {
    private _stages: IObservableArray<ChecksPanelData>;
    private _currentUserId : string;

    public get data(): IObservableArray<ChecksPanelData> {
        return this._stages;
    }

    public initialize() {
        this._stages = new ObservableArray<ChecksPanelData>();

        const vssPageService = this.pageContext.getService<IVssPageService>("IVssPageService");
        const vssPageData = vssPageService.getData();
        
        if (vssPageData) { 
            this._currentUserId = vssPageData.user.id;
        }
        else {
            this._currentUserId = "";
        }
    }

    public fetchData(runId: number, stageIds: string[], checkListItemType: CheckListItemType ) {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const params = {
            buildId: runId.toString(),
            stageIds: stageIds.join(","),
            checkListItemType: checkListItemType
        }
        contributionService.getDataAsync<ChecksPanelData[]>("ms.vss-build-web.checks-panel-data-provider", params, true).then((data: ChecksPanelData[] | undefined) => {
            if (data) {
                this._stages.value = data;
            }
        });
    }
    
    public isCurrentUserBlockedFromApproving(approvals: ApprovalDetails[]) {
        for (let i = 0; i < approvals.length; i++) {
            if (approvals[i].status === ApprovalStatus.Pending) {
                let approval = approvals[i];
                for (let j = 0; j < approval.blockedApprovers.length; j++) {
                    if (approval.blockedApprovers[j].id.toLowerCase() === this._currentUserId.toLowerCase()
                        && approval.steps.find(x => x.permissions === ApprovalPermissions.Reassign)) {
                        return true;
                    }
                }
            }
        }
    
        return false;
    }
}

Services.add("IChecksPanelService", { serviceFactory: ChecksPanelService });